import { z } from 'zod'
import { IdParamSchema, RefParamSchema } from './params'

export const StaffSchema = z.object({
  id: IdParamSchema,
  ref: RefParamSchema,
  name: z.string(),
  store_id: z.number(),
})
